import { Component, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
 

@Component({
  selector: 'app-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.css'],
})
export class ButtonsComponent implements OnInit {
  showExprotAction: boolean = false;
  status = 'Enable';
   
  codeToggleBtn: any = `
  <button class="btn-dt-edit">
    <mat-icon aria-hidden="false" aria-label="Example home icon">create</mat-icon>
    Modifier
  </button>
  <button class="btn-dt-delete" >
    <mat-icon aria-hidden="false" aria-label="Example home icon">check</mat-icon>
    Supprimer
  </button>
`;

  headercode: any = `
<div class="card-head text-center">
    <div class="row details-header">
    <button  type="button" class="btn-dt-retour">
      <div class="icon-position">
        <i class="fa-solid fa-arrow-left fa-icon-style fa-lg"></i>
      </div>
      <span> Retour à la liste </span>
    </button>
      <div class="row details-spinner">
          <ng-container> <!-- *ngIf="show_loading" -->
            <div>
              <div class="col-12 text-center">
                <div class="spinner-style">
                  <mat-spinner [diameter]="30"></mat-spinner>
                </div>
              </div>
            </div>
          </ng-container>
          <button  type="button" class="btn-load" type="button">
            <i class="fa-solid fa-rotate-right"></i>
          </button>
      </div>
      <button  type="button" class="btn-dt-save">
        <i class="fa-solid fa-circle-check fa-lg"></i>
        
          Enregistrer
      </button>
  </div>

  <div class="col-1 d-flex align-items-center">
  <button type="button" class="btn-dt-retourr mt-1" (click)="returnToList()">
      <div class="icon-position">
          <i class="fa-solid fa-arrow-left fa-icon-style fa-lg"></i>
      </div>
  </button>
</div>
</div>  `;

  codeHeaderBtn: any = `

  <button type="button" class="btn-dt-print">
    <i class="fa-solid fa-print fa-lg"></i>
    Imprimer
  </button>

  <button type="button" class="btn-dt-actions-groupee">
  Actions Groupées
</button>

  <button  type="button" class="btn-dt-exporter">
  <i class="fa-solid fa-file-excel fa-lg"></i>
    Exporter en .csv
  </button>

  <button type="button" class="btn-dt-action">
    <div class="icon-position">
      <img class="icon-btn-action" src="assets/icons/action-icon.svg">
    </div>
    <span>Actions</span>
  </button>

  <button type="button" class="btn-dt-retour btn-custom-details">
    <div class="icon-position">
      <i class="fa-solid fa-arrow-left fa-icon-style fa-lg"></i>
    </div>
    <span> Retour à la liste </span>
  </button>

  <button  type="button" class="btn-dt-save">
    <i class="fa-solid fa-circle-check fa-lg"></i>
      Enregistrer
  </button>

  <button  type="button" class="btn-dt-retour">
    <div class="icon-position">
      <i class="fa-solid fa-arrow-left fa-icon-style fa-lg"></i>
    </div>
    <span> Retour à la liste </span>
  </button>

  <button  type="button" class="btn-dt-link">
  <i class="fa-solid fa-link fa-icon-style"></i>
    Lien
  </button>

  <button  type="button" class="btn-dt-send">
    <img class="icon-btn-send" src="assets/icons/paper-plane-icon.svg">
    Envoyer
  </button>

  <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
  <i class="fa-solid fa-ellipsis-vertical fa fa-lg icon-menu-bleu"></i>
  </button>

  <button  type="button" class="btn-keygen" id="keygen">
     <i class="fa-solid fa-key fa-lg"></i>
    Générer
  </button>

      <button type="button" class="btn-suivant">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1377 0.268984C13.4963 0.627628 13.4963 1.20911 13.1377 1.56775L5.70542 9L13.1377 16.4322C13.4963 16.7909 13.4963 17.3724 13.1377 17.731C12.779 18.0897 12.1975 18.0897 11.8389 17.731L3.75726 9.64938C3.39862 9.29074 3.39862 8.70926 3.75726 8.35062L11.8389 0.268984C12.1975 -0.0896612 12.779 -0.0896612 13.1377 0.268984Z"  />
            </svg>
          Précédent 
        
        
</button>
      <button type="button" class="btn-suivant ml-4">
          Suivant 
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.86234 17.731C4.50369 17.3724 4.50369 16.7909 4.86234 16.4322L12.2946 9L4.86234 1.56775C4.50369 1.20911 4.50369 0.627628 4.86234 0.268982C5.22098 -0.0896626 5.80246 -0.0896626 6.1611 0.268982L14.2427 8.35062C14.6014 8.70926 14.6014 9.29074 14.2427 9.64938L6.1611 17.731C5.80246 18.0897 5.22098 18.0897 4.86234 17.731Z" />
            </svg>
</button>

<button type="button"  class="Avenant-btn"
data-toggle="modal" data-target="#myModal">
<i class="fa-solid fa-square-plus fa fa-lg"></i>
Créer un avenant
</button>
<button type="button" class="btn-dt-save-blue" >
        <div class="icon-position">
          <img src="/assets/icons/save-icon-blue.svg">&nbsp;&nbsp;
        </div>
        <span>Mettre à jour </span>
      </button>

      <button type="button" class="changeStatus" >
      <span class="mb-1">Changer le statut</span>
      <i class="fa-solid fa-arrow-right fa-icon-style sIcon ml-3"></i>
  </button>
  <button type="button" class="filtrer" >
   <img src="assets/icons/filtre.svg" class="mr-3" alt="">
   Filtrer
  </button>
  `;

  btndetails: any = `
    <button type="button" class="btn-dt-save-blue">
      <div class="icon-position">
        <img src="/assets/icons/save-icon-blue.svg">&nbsp;&nbsp;
      </div>
      <span>Enregistrer</span>
    </button>

    <button  type="button" class="btn-dt-save-white">
      <div class="icon-position">
        <img src="/assets/icons/save-icon-white.svg">&nbsp;&nbsp;
      </div>
      <span> Enregistrer</span>
    </button>

    <button  type="button" class="btn-dt-details">
      <div class="icon-position">
      <i class="fa-solid fa-user fa-icon-style"></i>
      </div>
      <span> Buttons Details </span>
    </button>

    <button type="button" class="btn-dt-add" data-title="text ici">
      <i class="fa-solid fa-plus fa-lg"></i>
    </button>

    <button  type="button" class="btn-dt-list">
      <img src="/assets/icons/edit-icon.svg">
    </button>

    <button  type="button" class="btn-dt-list">
      <img src="/assets/icons/pdf-icon.svg">
    </button>

    <button  type="button" class="btn-dt-list">
      <img src="/assets/icons/share-icon.svg">
    </button>

    <button  type="button" class="btn-dt-list">
      <img src="/assets/icons/phone-icon.svg">
    </button>

    <button type="button" class="btn-dt-edit-tk" data-title="text ici">
      <img src="/assets/icons/edit-2-icon.svg">
    </button>
    button type="button"  class="Avenant-btn"
data-toggle="modal" data-target="#myModal">
<i class="fa-solid fa-square-plus fa fa-lg"></i>
Créer un avenant
</button>
<button type="button" class="btn-dt-save-blue" >
        <div class="icon-position">
          <img src="/assets/icons/save-icon-blue.svg">&nbsp;&nbsp;
        </div>
        <span>Mettre à jour </span>
      </button>

      <button type="button" class="changeStatus" >
      <span class="mb-1">Changer le statut</span>
      <i class="fa-solid fa-arrow-right fa-icon-style sIcon ml-3"></i>
  </button>

<button class="statut-envoieCancel text-center d-flex align-items-center " >
<i class="fa-solid fa-circle-xmark  fa-lg mr-2"></i>
        <b>{{'languages.communication.AnnulerLenvoie' | translate}}</b>
      </button>
  `;

  codeAddBtn: any = `
  <button  type="button" class="btn-dt-ajouter">
    <i class="fa-solid fa-circle-plus fa fa-lg"></i>
      Ajouter
  </button>

  <button  type="button" class="add-btn-em">
    <img class="fa-icon-add" src="assets/icons/add-icon.svg">&nbsp;
    Ajouter
  </button>

  <button  type="button" class="add-btn-en">
    <i class="fa fa-plus-circle fa-2x" aria-hidden="true"></i>
  </button>

  <button  type="button" class="btn-dt-fermer">
  <i class="fa-solid fa-circle-xmark fa fa-lg"></i>
    Fermer
  </button>
  <button type="button"  class="add-btn-em">
      <img class="fa-icon-add" src="assets/icons/add-icon.svg">&nbsp;
      <span>Ajouter un objet</span>

    </button>
  `;

  codeSearchBtn: any = `
  <button  type="button" class="add-btn-search">
    <i class="fa-solid fa-magnifying-glass fa fa-lg fa-flip-horizontal"></i>&nbsp;&nbsp;
    Rechercher par&nbsp;&nbsp;
    <i class="fa-solid fa-caret-down fa fa-lg"></i>
  </button>

  <form class="example">
    <input type="text" placeholder="Search.." name="search2">
    <button type="submit"><i class="fa fa-search"></i></button>
  </form>
  <div class="filter-bubble">
    <div class="row">
      <div class="col">
        <div class="filter-bubble-icon">
          <i class="fa-solid fa-magnifying-glass"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<button 
type="button"
   class="add-btn-searchOpp" >
   <i class="fa-solid fa-magnifying-glass fa fa-lg fa-flip-horizontal"></i>
   &nbsp;
   Rechercher par

</button>
`;

  codeRadioButtons: any = `<mat-radio-group> c
    <mat-radio-button class="space-radio" value="1" >Prospect Particulier</mat-radio-button>
    <mat-radio-button class="space-radio"  value="2">Prospect Professionnel</mat-radio-button>
    </mat-radio-group>`;

  codeBasicButtons: any = `
  <button class="test-button" mat-button>Basic</button>
  <button mat-button color="primary">Primary</button>
  <button mat-button color="accent">Accent</button>
  <button mat-button color="warn">Warn</button>
  <button mat-button disabled>Disabled</button>
  <a mat-button routerLink=".">Link</a>
`;

  codeRaisedButtons: any = `
  <button mat-stroked-button>Basic</button>
  <button mat-stroked-button color="primary">Primary</button>
  <button mat-stroked-button color="accent">Accent</button>
  <button mat-stroked-button color="warn">Warn</button>
  <button mat-stroked-button disabled>Disabled</button>
  <a mat-stroked-button routerLink=".">Link</a>`;

  codeStrokedButtons: any = `
  <button mat-stroked-button>Basic</button>
  <button mat-stroked-button color="primary">Primary</button>
  <button mat-stroked-button color="accent">Accent</button>
  <button mat-stroked-button color="warn">Warn</button>
  <button mat-stroked-button disabled>Disabled</button>
  <a mat-stroked-button routerLink=".">Link</a>`;

  codeFlatButtons: any = `
  <button mat-flat-button>Basic</button>
  <button mat-flat-button color="primary">Primary</button>
  <button mat-flat-button color="accent">Accent</button>
  <button mat-flat-button color="warn">Warn</button>
  <button mat-flat-button disabled>Disabled</button>
  <a mat-flat-button routerLink=".">Link</a>`;

  codeIconButtons: any = `
  <button mat-icon-button aria-label="Example icon-button with a heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <button mat-icon-button color="primary" aria-label="Example icon-button with a heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <button mat-icon-button color="accent" aria-label="Example icon-button with a heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <button mat-icon-button color="warn" aria-label="Example icon-button with a heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <button mat-icon-button disabled aria-label="Example icon-button with a heart icon">
    <mat-icon>favorite</mat-icon>
  </button>`;

  codeFabButtons: any = `
  <button mat-fab>Basic</button>
  <button mat-fab color="primary">Primary</button>
  <button mat-fab color="accent">Accent</button>
  <button mat-fab color="warn">Warn</button>
  <button mat-fab disabled>Disabled</button>
  <button mat-fab aria-label="Example icon-button with a heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <a mat-fab routerLink=".">Link</a>`;

  codeMiniFabButtons: any = `
  <button mat-mini-fab>Basic</button>
  <button mat-mini-fab color="primary">Primary</button>
  <button mat-mini-fab color="accent">Accent</button>
  <button mat-mini-fab color="warn">Warn</button>
  <button mat-mini-fab disabled>Disabled</button>
  <button mat-mini-fab aria-label="Example icon-button with a heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <a mat-mini-fab routerLink=".">Link</a>`;

  codeDataTableBtn: any = `
  <button type="button" class="btn-dt-add" data-title="text ici">
    <i class="fa-solid fa-plus fa-lg"></i>
  </button>

  <button  type="button" class="btn-edit">
  <i class="fa-solid fa-pen-to-square ml-1 fa-lg"></i>

</button>

  <button  type="button" class="btn-dt-delete">
  <i class="fa-solid fa-trash"></i>
  </button>


  <button  type="button" class="btn-dt-desactiver">
    <i class="fa-solid fa-lock fa-fw"></i>
    Désactiver
  </button>

  <button  type="button" class="btn-dt-activer">
      <i class="fa-solid fa-unlock-keyhole fa-fw"></i>
    Activer
  </button>

  <button  type="button" class="btn-dt-ouvrir">
    <i class="fa-solid fa-up-right-from-square con-btn-ouvrir"></i>
    Ouvrir
  </button>

  <button  type="button" class="btn-dt-filter">
    <i class="fa-solid fa-filter fa-fw"></i>
    Filtrer
  </button>

  <button type="button" class="btn btn-dt-settings" data-title="text ici">
    <img class="icon-btn-settings" src="assets/icons/settings-icon.svg">
  </button>

  <span class="add-file-contaniner">
  <i class="fa-solid fa-circle-plus add-file-icon"></i>
  <i class="fa-solid fa-paperclip add-file-paper-icon"></i>
   
  </span>`;

  codebtnicon: any = `
  <span>
    <img src="assets/icons/check-circle.svg">
  </span>

  <span>
    <img src="assets/icons/times-icon.svg">
  </span>

  <span>
    <img src="assets/icons/trash-icon-red.svg" >
  </span>

  <button  type="button" class="btn-load" type="button">
    <i class="fa-solid fa-rotate-right"></i>
  </button>

  <input type='checkbox' id="perm" data-title="Text ici" class="star" />
  <label for="perm"></label>

  <button  type="button" class="btn-dt-chevron-white">
    <img src="assets/icons/chevron-white-icon.svg">
  </button>

  <button  type="button" class="btn-dt-chevron">
    <img src="assets/icons/chevron-black-icon.svg">
  </button>`;

  codebtnpopup: any = `
  <button  type="button" class="btn-dt-save-popup">
  <i class="fa-solid fa-circle-check fa-lg fa-icon-style"></i>
    Enregistrer
  </button>

  <button  type="button" class="btn-dt-cancel-popup">
  <i class="fa-solid fa-circle-xmark fa-icon-style"></i>
    Annuler
  </button>

  <button  type="button" class="btn-dt-edit-popup">
  <i class="fa-solid fa-pen-to-square fa-icon-style"></i>
    Modifier
  </button>
  

  <button  type="button" class="btn-dt-delete-popup">
    <img class="icon-btn-action" src="assets/icons/trash-icon.svg">&nbsp;
    Supprimer
  </button> `;

  codebtn: any = `
  <button id="Imprimer">
    <svg class="Trac_imp" viewBox="0 0 132 40">
        <path id="Trac_imp" d="M 5 0 L 127 0 C 129.7614288330078 0 132 2.238576173782349 132 5 L 132 35 C 132 37.76142501831055 129.7614288330078 40 127 40 L 5 40 C 2.238576173782349 40 0 37.76142501831055 0 35 L 0 5 C 0 2.238576173782349 2.238576173782349 0 5 0 Z">
        </path>
    </svg>
    <div id="Groupe_printer">
        <div id="printer">
            <svg class="Trac_printer" viewBox="0 6 22 11">
                <path id="Trac_printer" d="M 19.70833396911621 17 L 16.95833396911621 17 C 16.7053337097168 17 16.5 16.7946662902832 16.5 16.54166793823242 C 16.5 16.28866767883301 16.7053337097168 16.08333396911621 16.95833396911621 16.08333396911621 L 19.70833396911621 16.08333396911621 C 20.46641731262207 16.08333396911621 21.08333396911621 15.46641635894775 21.08333396911621 14.70833396911621 L 21.08333396911621 8.291666984558105 C 21.08333396911621 7.533583164215088 20.46641731262207 6.916666984558105 19.70833396911621 6.916666984558105 L 2.291666746139526 6.916666984558105 C 1.533583402633667 6.916666984558105 0.9166666865348816 7.533583164215088 0.9166666865348816 8.291666984558105 L 0.9166666865348816 14.70833396911621 C 0.9166666865348816 15.46641635894775 1.533583402633667 16.08333396911621 2.291666746139526 16.08333396911621 L 5.041666984558105 16.08333396911621 C 5.294666767120361 16.08333396911621 5.5 16.28866767883301 5.5 16.54166793823242 C 5.5 16.7946662902832 5.294666767120361 17 5.041666984558105 17 L 2.291666746139526 17 C 1.027583360671997 17 0 15.97150039672852 0 14.70833396911621 L 0 8.291666984558105 C 0 7.028500080108643 1.027583360671997 6 2.291666746139526 6 L 19.70833396911621 6 C 20.97241592407227 6 22 7.028500080108643 22 8.291666984558105 L 22 14.70833396911621 C 22 15.97150039672852 20.97241592407227 17 19.70833396911621 17 Z">
                </path>
            </svg>
            <svg class="Trac_6352" viewBox="8 20 6.417 0.917">
                <path id="Trac_6352" d="M 13.95833396911621 20.91666603088379 L 8.458333969116211 20.91666603088379 C 8.205333709716797 20.91666603088379 8 20.71133232116699 8 20.45833396911621 C 8 20.2053337097168 8.205333709716797 20 8.458333969116211 20 L 13.95833396911621 20 C 14.21133422851563 20 14.41666698455811 20.2053337097168 14.41666698455811 20.45833396911621 C 14.41666698455811 20.71133232116699 14.21133422851563 20.91666603088379 13.95833396911621 20.91666603088379 Z">
                </path>
            </svg>
            <svg class="Trac_6353" viewBox="8 18 6.417 0.917">
                <path id="Trac_6353" d="M 13.95833396911621 18.91666793823242 L 8.458333969116211 18.91666793823242 C 8.205333709716797 18.91666793823242 8 18.71133232116699 8 18.45833396911621 C 8 18.2053337097168 8.205333709716797 18 8.458333969116211 18 L 13.95833396911621 18 C 14.21133422851563 18 14.41666698455811 18.2053337097168 14.41666698455811 18.45833396911621 C 14.41666698455811 18.71133232116699 14.21133422851563 18.91666793823242 13.95833396911621 18.91666793823242 Z">
                </path>
            </svg>
            <svg class="Trac_6354" viewBox="8 16 2.75 0.917">
                <path id="Trac_6354" d="M 10.29166698455811 16.91666793823242 L 8.458333969116211 16.91666793823242 C 8.205333709716797 16.91666793823242 8 16.71133232116699 8 16.45833396911621 C 8 16.20533561706543 8.205333709716797 16 8.458333969116211 16 L 10.29166698455811 16 C 10.54466724395752 16 10.75000095367432 16.20533561706543 10.75000095367432 16.45833396911621 C 10.75000095367432 16.71133232116699 10.54466724395752 16.91666793823242 10.29166698455811 16.91666793823242 Z">
                </path>
            </svg>
            <svg class="Trac_6355" viewBox="5 0 12.833 6.417">
                <path id="Trac_6355" d="M 17.375 6.416666984558105 C 17.12199974060059 6.416666984558105 16.91666603088379 6.211333274841309 16.91666603088379 5.958333492279053 L 16.91666603088379 2.291666746139526 C 16.91666603088379 1.533583402633667 16.29974937438965 0.9166666865348816 15.54166698455811 0.9166666865348816 L 7.291666507720947 0.9166666865348816 C 6.533583164215088 0.9166666865348816 5.916666507720947 1.533583402633667 5.916666507720947 2.291666746139526 L 5.916666507720947 5.958333492279053 C 5.916666507720947 6.211333274841309 5.711333274841309 6.416666984558105 5.458333492279053 6.416666984558105 C 5.205333232879639 6.416666984558105 5 6.211333274841309 5 5.958333492279053 L 5 2.291666746139526 C 5 1.028499960899353 6.027583599090576 0 7.291666507720947 0 L 15.54166698455811 0 C 16.80574989318848 0 17.83333396911621 1.028499960899353 17.83333396911621 2.291666746139526 L 17.83333396911621 5.958333492279053 C 17.83333396911621 6.211333274841309 17.62799835205078 6.416666984558105 17.375 6.416666984558105 Z">
                </path>
            </svg>
            <svg class="Trac_6356" viewBox="5 13 12.833 10.083">
                <path id="Trac_6356" d="M 15.54166698455811 23.08333396911621 L 7.291666507720947 23.08333396911621 C 6.027583599090576 23.08333396911621 5 22.05483436584473 5 20.79166793823242 L 5 13.45833301544189 C 5 13.2053337097168 5.205333232879639 13 5.458333492279053 13 L 17.375 13 C 17.62799835205078 13 17.83333396911621 13.2053337097168 17.83333396911621 13.45833301544189 L 17.83333396911621 20.79166793823242 C 17.83333396911621 22.05483436584473 16.80574989318848 23.08333396911621 15.54166698455811 23.08333396911621 Z M 5.916666507720947 13.91666698455811 L 5.916666507720947 20.79166793823242 C 5.916666507720947 21.54975128173828 6.533583164215088 22.16666793823242 7.291666507720947 22.16666793823242 L 15.54166698455811 22.16666793823242 C 16.29974937438965 22.16666793823242 16.91666603088379 21.54975128173828 16.91666603088379 20.79166793823242 L 16.91666603088379 13.91666698455811 L 5.916666507720947 13.91666698455811 Z">
                </path>
            </svg>
        </div>
        <div id="Latest_customers_gs">
            <span>Imprimer</span>
        </div>
    </div>
  </button>

  <!-------------Exporter------------------->


<button id="Exporter">
    <svg class="Trac_exp" id="Trac_exp" viewBox="0 0 149 40">
        <path  d="M 5 0 L 144 0 C 146.7614288330078 0 149 2.238576173782349 149 5 L 149 35 C 149 37.76142501831055 146.7614288330078 40 144 40 L 5 40 C 2.238576173782349 40 0 37.76142501831055 0 35 L 0 5 C 0 2.238576173782349 2.238576173782349 0 5 0 Z">
        </path>
    </svg>
    <div id="Groupe_exp">
        <div id="csv-file-format-extension">
            <svg class="icon_exp" viewBox="31.36 0 17.712 20">
                <path id="icon_exp" d="M 47.95118713378906 7.153902530670166 L 47.47100067138672 7.153902530670166 L 47.47100067138672 4.836482524871826 C 47.47100067138672 4.82192850112915 47.46866989135742 4.807483673095703 47.46677017211914 4.792710304260254 C 47.46600723266602 4.700788497924805 47.43671798706055 4.610325813293457 47.37371826171875 4.538830757141113 L 43.51762771606445 0.1341258734464645 C 43.51649475097656 0.1328856498003006 43.51529312133789 0.1325208842754364 43.5145263671875 0.1313900947570801 C 43.49158096313477 0.1056008711457253 43.46477127075195 0.08426182717084885 43.43642807006836 0.06587743014097214 C 43.42800140380859 0.06015054136514664 43.41957855224609 0.05544501170516014 43.41075134277344 0.05059356987476349 C 43.3862419128418 0.03727947548031807 43.36019515991211 0.02608104050159454 43.33338165283203 0.01801962777972221 C 43.32612609863281 0.01612282730638981 43.31963348388672 0.01313171163201332 43.31237030029297 0.01116195600479841 C 43.28318786621094 0.004304284229874611 43.25295257568359 0 43.22238540649414 0 L 33.74547958374023 0 C 33.31271743774414 0 32.96118927001953 0.3519664108753204 32.96118927001953 0.7843280434608459 L 32.96118927001953 7.153683662414551 L 32.48104095458984 7.153683662414551 C 31.8619556427002 7.153683662414551 31.3599967956543 7.655461311340332 31.3599967956543 8.274621963500977 L 31.3599967956543 14.10400772094727 C 31.3599967956543 14.72287654876709 31.8619556427002 15.22516345977783 32.48104095458984 15.22516345977783 L 32.96118927001953 15.22516345977783 L 32.96118927001953 19.2157096862793 C 32.96118927001953 19.64810752868652 33.31271743774414 20 33.74547958374023 20 L 46.68667602539063 20 C 47.11903381347656 20 47.47100067138672 19.64810752868652 47.47100067138672 19.2157096862793 L 47.47100067138672 15.22520065307617 L 47.95118713378906 15.22520065307617 C 48.57005310058594 15.22520065307617 49.07209014892578 14.72313117980957 49.07209014892578 14.10422706604004 L 49.07209014892578 8.274840354919434 C 49.07212448120117 7.655497550964355 48.57005310058594 7.153902530670166 47.95118713378906 7.153902530670166 Z M 33.74547958374023 0.7843280434608459 L 42.83018493652344 0.7843280434608459 L 42.83018493652344 4.797015190124512 C 42.83018493652344 5.013688564300537 43.00592803955078 5.189178943634033 43.22234344482422 5.189178943634033 L 46.68667602539063 5.189178943634033 L 46.68667602539063 7.153865814208984 L 33.74547958374023 7.153865814208984 L 33.74547958374023 0.7843280434608459 Z M 39.64968490600586 11.42386054992676 C 38.67647552490234 11.08495235443115 38.04239654541016 10.54648017883301 38.04239654541016 9.695253372192383 C 38.04239654541016 8.695638656616211 38.87629699707031 7.930934906005859 40.25775146484375 7.930934906005859 C 40.91823959350586 7.930934906005859 41.40484619140625 8.069948196411133 41.75214385986328 8.226653099060059 L 41.45703887939453 9.295429229736328 C 41.22249984741211 9.182095527648926 40.80549240112305 9.017036437988281 40.23178100585938 9.017036437988281 C 39.65847396850586 9.017036437988281 39.38044357299805 9.277810096740723 39.38044357299805 9.581882476806641 C 39.38044357299805 9.955662727355957 39.71045303344727 10.1206111907959 40.46672821044922 10.40742874145508 C 41.50052642822266 10.78967094421387 41.98712539672852 11.3280725479126 41.98712539672852 12.15372753143311 C 41.98712539672852 13.13528728485107 41.23128890991211 13.96977138519287 39.62371063232422 13.96977138519287 C 38.95479965209961 13.96977138519287 38.29416275024414 13.79555797576904 37.96411514282227 13.61339282989502 L 38.23331832885742 12.51849842071533 C 38.58977127075195 12.70139503479004 39.13703536987305 12.88348865509033 39.7020263671875 12.88348865509033 C 40.31013870239258 12.88348865509033 40.63175201416016 12.63150596618652 40.63175201416016 12.24893569946289 C 40.63156890869141 11.8838005065918 40.35335922241211 11.67547988891602 39.64968490600586 11.42386054992676 Z M 32.75027847290039 11.04129028320313 C 32.75027847290039 9.043044090270996 34.17557907104492 7.930934906005859 35.9476318359375 7.930934906005859 C 36.63420104980469 7.930934906005859 37.15549468994141 8.069948196411133 37.39026260375977 8.191708564758301 L 37.12062454223633 9.242829322814941 C 36.85142135620117 9.13033390045166 36.47745895385742 9.026192665100098 36.00840377807617 9.026192665100098 C 34.95706176757813 9.026192665100098 34.14056015014648 9.659978866577148 34.14056015014648 10.96308326721191 C 34.14056015014648 12.13611030578613 34.83548736572266 12.87447738647461 36.01752090454102 12.87447738647461 C 36.41683197021484 12.87447738647461 36.86002731323242 12.78773403167725 37.12062454223633 12.68341064453125 L 37.32062530517578 13.71738719940186 C 37.07725143432617 13.83922004699707 36.53002166748047 13.96977138519287 35.81748199462891 13.96977138519287 C 33.79301071166992 13.96980953216553 32.75027847290039 12.70945739746094 32.75027847290039 11.04129028320313 Z M 46.68667602539063 19.00312042236328 L 33.74547958374023 19.00312042236328 L 33.74547958374023 15.22519969940186 L 46.68667602539063 15.22519969940186 L 46.68667602539063 19.00312042236328 Z M 45.81064605712891 13.88251972198486 L 44.26405334472656 13.88251972198486 L 42.38731384277344 8.026651382446289 L 43.838623046875 8.026651382446289 L 44.55087280273438 10.50321865081787 C 44.750732421875 11.19795989990234 44.9331169128418 11.86694812774658 45.07245635986328 12.59688949584961 L 45.09832382202148 12.59688949584961 C 45.2459831237793 11.8929557800293 45.42825317382813 11.19792366027832 45.6281852722168 10.52889919281006 L 46.37548828125 8.026651382446289 L 47.78346633911133 8.026651382446289 L 45.81064605712891 13.88251972198486 Z">
                </path>
            </svg>
        </div>
        <div id="Latest_customers_gy">
            <span style="color:rgba(255,255,255,1)">Exporter en .csv</span>
        </div>
    </div>
  </button>


  <!-- -----------------Ouvrir---------------------- -->
<button id="Ouvrir">

    <div id="Groupe_Ouvrir">
        <svg class="Shape_BG" viewBox="0 0 92 28">
            <path id="Shape_BG" d="M 7.960395336151123 0 L 84.03960418701172 0 C 88.43600463867188 0 92 2.686291217803955 92 6.000000476837158 L 92 22.00000190734863 C 92 25.31371116638184 88.43600463867188 28.00000190734863 84.03960418701172 28.00000190734863 L 7.960395336151123 28.00000190734863 C 3.563990592956543 28.00000190734863 0 25.31371116638184 0 22.00000190734863 L 0 6.000000476837158 C 0 2.686291217803955 3.563990592956543 0 7.960395336151123 0 Z">
            </path>
        </svg>
    </div>
    <div id="icon_Ouvrir">
        <div id="Groupe_2836">
            <div id="Pending">
                <span>Ouvrir</span>
            </div>
        </div>
        <svg class="icons8-external-link" viewBox="3 3 12.374 12.374">
            <path id="icons8-external-link" d="M 4.374928951263428 2.999999761581421 C 3.623489379882813 2.999999761581421 2.999999523162842 3.623489379882813 2.999999523162842 4.374929904937744 L 2.999999523162842 13.99943923950195 C 2.999999523162842 14.75090789794922 3.623489379882813 15.37436866760254 4.374928951263428 15.37436866760254 L 13.99943733215332 15.37436866760254 C 14.75090408325195 15.37436866760254 15.37436676025391 14.75090789794922 15.37436676025391 13.99943923950195 L 15.37436676025391 9.187185287475586 L 13.99943733215332 9.187185287475586 L 13.99943733215332 13.99943923950195 L 4.374928951263428 13.99943923950195 L 4.374928951263428 4.374929904937744 L 9.18718433380127 4.374929904937744 L 9.18718433380127 2.999999761581421 L 4.374928951263428 2.999999761581421 Z M 10.56211090087891 2.999999761581421 L 10.56211090087891 4.374929904937744 L 13.0272912979126 4.374929904937744 L 6.638730049133301 10.76354217529297 L 7.610846996307373 11.73561477661133 L 13.99943733215332 5.347046852111816 L 13.99943733215332 7.812255382537842 L 15.37436676025391 7.812255382537842 L 15.37436676025391 2.999999761581421 L 10.56211090087891 2.999999761581421 Z">
            </path>
        </svg>
    </div>
</button>

<!--  ---------launch---------------- -->
<button id="launch">
    <svg class="icons8-right-arrow_2_dj" viewBox="0 0 14.358 6.163">
        <path id="icons8-right-arrow_2_dj" d="M 11.27093410491943 0 C 11.06238079071045 7.455877494066954e-05 10.87466430664063 0.126491367816925 10.79619312286377 0.3197117745876312 C 10.71772193908691 0.5129321813583374 10.76414012908936 0.734431266784668 10.91358947753906 0.8798890113830566 L 12.60133743286133 2.567638397216797 L 0.5125924348831177 2.567638397216797 C 0.2294954508543015 2.567586898803711 0 2.79707670211792 0 3.080165147781372 C 0 3.363253593444824 0.2294954508543015 3.592742204666138 0.5125924348831177 3.592742204666138 L 12.60133743286133 3.592690706253052 L 10.91358947753906 5.280438423156738 C 10.77925968170166 5.408889770507813 10.72498893737793 5.59998893737793 10.77175521850586 5.779866218566895 C 10.81852245330811 5.959744930267334 10.95899677276611 6.100216865539551 11.13887882232666 6.146982192993164 C 11.31876182556152 6.193746089935303 11.50986862182617 6.139476776123047 11.63832378387451 6.005151748657227 L 14.15597724914551 3.487571477890015 C 14.2828483581543 3.390887498855591 14.35747718811035 3.240653038024902 14.35786914825439 3.081144571304321 C 14.35826110839844 2.921635866165161 14.2843713760376 2.771036863327026 14.1579761505127 2.673730611801147 C 14.1569881439209 2.673061370849609 14.15599727630615 2.672394990921021 14.15500354766846 2.671732187271118 L 11.63832378387451 0.1551627069711685 C 11.54182624816895 0.05597057566046715 11.40932178497314 8.045910362852737e-06 11.27093315124512 0 Z">
        </path>
    </svg>
    <svg class="icons8-right-arrow_2_dk" viewBox="0 0 14.358 6.163">
        <path id="icons8-right-arrow_2_dk" d="M 11.27093410491943 0 C 11.06238079071045 7.455877494066954e-05 10.87466430664063 0.126491367816925 10.79619312286377 0.3197117745876312 C 10.71772193908691 0.5129321813583374 10.76414012908936 0.734431266784668 10.91358947753906 0.8798890113830566 L 12.60133743286133 2.567638397216797 L 0.5125924348831177 2.567638397216797 C 0.2294954508543015 2.567586898803711 0 2.79707670211792 0 3.080165147781372 C 0 3.363253593444824 0.2294954508543015 3.592742204666138 0.5125924348831177 3.592742204666138 L 12.60133743286133 3.592690706253052 L 10.91358947753906 5.280438423156738 C 10.77925968170166 5.408889770507813 10.72498893737793 5.59998893737793 10.77175521850586 5.779866218566895 C 10.81852245330811 5.959744930267334 10.95899677276611 6.100216865539551 11.13887882232666 6.146982192993164 C 11.31876182556152 6.193746089935303 11.50986862182617 6.139476776123047 11.63832378387451 6.005151748657227 L 14.15597724914551 3.487571477890015 C 14.2828483581543 3.390887498855591 14.35747718811035 3.240653038024902 14.35786914825439 3.081144571304321 C 14.35826110839844 2.921635866165161 14.2843713760376 2.771036863327026 14.1579761505127 2.673730611801147 C 14.1569881439209 2.673061370849609 14.15599727630615 2.672394990921021 14.15500354766846 2.671732187271118 L 11.63832378387451 0.1551627069711685 C 11.54182624816895 0.05597057566046715 11.40932178497314 8.045910362852737e-06 11.27093315124512 0 Z">
        </path>
    </svg>
  </button>
<!-- --------------------------------------- -->


  <!-- -------details------------>

  <button id="details">
    <svg class="Rectangle_edit">
        <rect id="Rectangle_edit" rx="7" ry="7" x="0" y="0" width="28" height="28">
        </rect>
    </svg>
    <div id="icon_edit">
        <div id="Groupe_e">
            <div id="G_e">
                <svg class="Trac_e" viewBox="0 34.137 12.106 13.114">
                    <path id="Trac_e" d="M 11.60126495361328 40.18983840942383 C 11.32267951965332 40.18983840942383 11.09685230255127 40.41566848754883 11.09685230255127 40.69425201416016 L 11.09685230255127 45.73826217651367 C 11.09685230255127 46.01684951782227 10.87102317810059 46.24267578125 10.59243869781494 46.24267578125 L 1.513209700584412 46.24267578125 C 1.234625577926636 46.24267578125 1.008796691894531 46.01684951782227 1.008796691894531 45.73826217651367 L 1.008796691894531 35.65021133422852 C 1.008796691894531 35.37162780761719 1.234625577926636 35.14579772949219 1.513209819793701 35.14579772949219 L 7.566048622131348 35.14579772949219 C 7.844632625579834 35.14579772949219 8.070461273193359 34.91996765136719 8.070461273193359 34.64138412475586 C 8.070461273193359 34.36279678344727 7.844632625579834 34.13700103759766 7.566048622131348 34.13700103759766 L 1.513209700584412 34.13700103759766 C 0.6774864196777344 34.13700103759766 0 34.81448745727539 0 35.65021133422852 L 0 45.73826217651367 C 0 46.5739860534668 0.6774864196777344 47.2514762878418 1.513209700584412 47.2514762878418 L 10.59246921539307 47.2514762878418 C 11.42819213867188 47.2514762878418 12.10567855834961 46.5739860534668 12.10567855834961 45.73826217651367 L 12.10567855834961 40.69422149658203 C 12.10567760467529 40.41566848754883 11.87984943389893 40.18983840942383 11.60126495361328 40.18983840942383 Z">
                    </path>
                </svg>
            </div>
        </div>
        <div id="Groupe_3235_h">
            <div id="Groupe_3234_h">
                <svg class="Trac_6363_h" viewBox="102.409 0.004 11.097 11.097">
                    <path id="Trac_6363_h" d="M 112.9400100708008 0.5693589448928833 C 112.5778427124023 0.2071343809366226 112.0866165161133 0.003678601467981935 111.5743942260742 0.003737678751349449 C 111.0618896484375 0.002259934786707163 110.5701522827148 0.2060703784227371 110.2089996337891 0.5696840286254883 L 103.5649642944336 7.213147163391113 C 103.5098495483398 7.268681049346924 103.46826171875 7.336184024810791 103.4434051513672 7.410367012023926 L 102.4346084594727 10.43678665161133 C 102.346565246582 10.70109462738037 102.4894638061523 10.98671340942383 102.753776550293 11.07472801208496 C 102.8050537109375 11.09181022644043 102.8587493896484 11.10052871704102 102.9127807617188 11.10058879852295 C 102.9669189453125 11.10050010681152 103.0207443237305 11.09181022644043 103.0721664428711 11.074875831604 L 106.0985870361328 10.06607913970947 C 106.1729202270508 10.0412540435791 106.2404479980469 9.999463081359863 106.2958068847656 9.94401741027832 L 112.9398040771484 3.300023078918457 C 113.6938934326172 2.546018600463867 113.6939849853516 1.32345175743103 112.9400100708008 0.5693589448928833 Z">
                    </path>
                </svg>
            </div>
        </div>
    </div>
</button>


<!-------------external link------------------>


<button id="externalLink">
    <svg class="Rectangle_Elink">
        <rect id="Rectangle_Elink" rx="7" ry="7" x="0" y="0" width="31" height="31">
        </rect>
    </svg>
    <svg class="icons-external-link" viewBox="3 3 13.669 13.669">
        <path id="icons-external-link" d="M 4.518732070922852 2.999999523162842 C 3.68869948387146 2.999999523162842 2.999999284744263 3.68869948387146 2.999999284744263 4.518733024597168 L 2.999999284744263 15.14986324310303 C 2.999999284744263 15.97992706298828 3.68869948387146 16.6685962677002 4.518732070922852 16.6685962677002 L 15.14986133575439 16.6685962677002 C 15.97992324829102 16.6685962677002 16.66859245300293 15.97992706298828 16.66859245300293 15.14986324310303 L 16.66859245300293 9.834298133850098 L 15.14986133575439 9.834298133850098 L 15.14986133575439 15.14986324310303 L 4.518732070922852 15.14986324310303 L 4.518732070922852 4.518733024597168 L 9.834297180175781 4.518733024597168 L 9.834297180175781 2.999999523162842 L 4.518732070922852 2.999999523162842 Z M 11.35302639007568 2.999999523162842 L 11.35302639007568 4.518733024597168 L 14.0760383605957 4.518733024597168 L 7.019302368164063 11.57552528381348 L 8.09309196472168 12.64926624298096 L 15.14986133575439 5.592523097991943 L 15.14986133575439 8.315566062927246 L 16.66859245300293 8.315566062927246 L 16.66859245300293 2.999999523162842 L 11.35302639007568 2.999999523162842 Z">
        </path>
    </svg>
</button>


<!-- -----plus----- -->

<div id="plus">
    <svg class="Ellipse">
        <ellipse id="Ellipse" rx="16.5" ry="17" cx="16.5" cy="17">
        </ellipse>
    </svg>
    <svg class="Rectangle_horiz">
        <rect id="Rectangle_horiz" rx="1.5" ry="1.5" x="0" y="0" width="15" height="3">
        </rect>
    </svg>
    <svg class="Rectangle_vert">
        <rect id="Rectangle_vert" rx="1.5" ry="1.5" x="0" y="0" width="15" height="3">
        </rect>
    </svg>
</div>



<!--  ----Entres--Afficher---- -->

<div id="EntresAfficher">
    <select class="Rectangle_1045" id="Rectangle_1045" rx="3" ry="3" x="0" y="0" width="60" height="27">
    <option id="ID10">5</option>
    <option id="ID10">10</option>
    <option id="ID10">15</option>
    <option id="ID10">20</option>
    </select>
    <div id="Afficher">
    <span>Afficher</span>
    </div>
    <div id="Entres">
    <span>Entrées</span>
    </div>

    <svg class="arrow" viewBox="0 0 2.101 3.9">
    <path id="arrow" d="M 2.056763887405396 1.842774391174316 L 0.2561084628105164 0.04212018102407455 C 0.1965001076459885 -0.0154515141621232 0.1015090122818947 -0.01379857212305069 0.04393725469708443 0.0458129346370697 C -0.01222959253937006 0.1039649397134781 -0.01222959253937006 0.1961517482995987 0.04393725097179413 0.2542949020862579 L 1.738503813743591 1.948861718177795 L 0.0439339205622673 3.643428802490234 C -0.01464463863521814 3.702019691467285 -0.01464463956654072 3.797011613845825 0.04393391683697701 3.855602979660034 C 0.1025354862213135 3.914186239242554 0.1975200325250626 3.914186239242554 0.256108433008194 3.855602979660034 L 2.056763887405396 2.054948806762695 C 2.11534595489502 1.996348857879639 2.11534595489502 1.901365995407104 2.056763887405396 1.842774391174316 Z">
    </path>
    </svg>
</div>


<!----------BRechercher------>

<div id="Rechercher">
    <svg class="Rectangle_Rech">
        <rect id="Rectangle_Rech" rx="10" ry="10" x="0" y="0" width="293" height="40">
        </rect>
    </svg>

        <input type="text"  maxlength="30" id="Recherche" placeholder="Recherche...">

    <svg class="icon_Rech" viewBox="0.109 0 17.008 17.348">
        <path id="icon_Rech" d="M 11.95827388763428 10.29428005218506 C 14.04072380065918 7.353691101074219 13.34422302246094 3.281826496124268 10.40365695953369 1.199884533882141 C 7.463069915771484 -0.8820624947547913 3.391204833984375 -0.1860909014940262 1.309258580207825 2.754999160766602 C -0.7726887464523315 5.695599555969238 -0.07671567797660828 9.76695728302002 2.864377498626709 11.84890842437744 C 4.963241577148438 13.33486747741699 7.738167762756348 13.44923114776611 9.951945304870605 12.14191246032715 L 14.76206111907959 16.9232063293457 C 15.28141021728516 17.46994018554688 16.1455135345459 17.49184417724609 16.69224739074707 16.97249031066895 C 17.23897933959961 16.45352172851563 17.26088333129883 15.58942127227783 16.74204254150391 15.04268932342529 C 16.72561264038086 15.02524280548096 16.70969390869141 15.00932312011719 16.69224739074707 14.99302101135254 L 11.95827388763428 10.29428005218506 Z M 6.629790782928467 10.74002170562744 C 4.306068420410156 10.74051856994629 2.422113418579102 8.858065605163574 2.420623302459717 6.53434419631958 C 2.420126676559448 4.210622310638428 4.302591323852539 2.32666802406311 6.626810073852539 2.325674772262573 C 8.947538375854492 2.324681282043457 10.83049964904785 4.204152584075928 10.83496856689453 6.524894237518311 C 10.83895492553711 8.849112510681152 8.957485198974609 10.73604869842529 6.632771015167236 10.74002170562744 C 6.631776809692383 10.74002170562744 6.631280422210693 10.74002170562744 6.629790782928467 10.74002170562744 Z M 6.629790782928467 10.74002170562744">
        </path>
    </svg>
</div>


</div>
`;

  codebttats: any = `
  <mat-tab-group>
  <mat-tab label="Exemple 1">
    <div class="example-large-box mat-elevation-z4">
      Content 1
    </div>
  </mat-tab>
  <mat-tab label="Exemple 2">
    <div class="example-small-box mat-elevation-z4">
      Content 2
    </div>
  </mat-tab>
  <mat-tab label="Exemple 3"> Content 3 </mat-tab>
</mat-tab-group>`;

  codebtntoggle: any = `
<div class="switch-toggle switch-ios">
  <input id="On" value="on" name="view" type="radio" checked>
  <label for="On" onclick="">ON</label>

  <input value="na" id="N/A" name="view" type="radio">
  <label for="N/A" onclick="">N/A</label>

  <input value="off" id="Off" name="view" type="radio">
  <label for="Off" onclick="">OFF</label>
  <a></a>
</div>
<div class="custom-slide-togglee" [class.checked]="isChecked" (click)="changeToggle()">
      <div class="togglee-thumb"></div>
      <span class="togglee-label">{{switcher}}</span>
    </div>
    // ts 
    // changeToggle(){
    //   this.isChecked = !this.isChecked;
    //   this.isChecked ? this.switcher="Oui" : this.switcher="Non"
    // }


    <mat-radio-group class=" TypeContratt col-6 d-flex align-items-center justify-content-center m-1" >
    <mat-radio-button class="col-3" value="N/R">N/R</mat-radio-button>
    <mat-radio-button class="col-3" value="Non Assure">Non Assure</mat-radio-button>
    <mat-radio-button class="col-3" value="Assure">Assure</mat-radio-button>
  </mat-radio-group>

`;

codeBtnLock:any =`
<div class="col-md-6 d-flex justify-content-end mb-1 pl-5 ">
  <div  *ngIf="isPasswordInputVisible" class="row passwordDiv" >
      <img  class=" col-3" src="assets/icons/lock.svg">
  <div class="col-9 d-flex  justify-content-end pl-0">
      <mat-form-field >
          <input
            matInput
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Entrer mot de passe"
            [(ngModel)]="password"
            (change)="validPass()"
            autocomplete="new-password">

        </mat-form-field>
        <button type="button" (click)="togglePasswordVisibility()" [disabled]="allow_to_change" class= "eyeBtn">
          <i class="fa-solid fa-eye-slash fa-lg" *ngIf="!showPassword"></i>
          <i class="fa-solid fa-eye fa-lg" *ngIf="showPassword"></i>
      </button>

  </div>
</div>
  <div class="col-1">
  <button type="button" (click)="togglePasswordInput()" [disabled]="allow_to_change" class="btn-lock " >
  <i class="fa-solid fa-lock-open fa fa-lg" *ngIf="allow_to_change"></i>
  <i class="fa-solid fa-lock fa fa-lg" *ngIf=" !allow_to_change"></i>
    </button>


  </div>
</div>
typescript : 

togglePasswordInput() {
  this.isPasswordInputVisible = !this.isPasswordInputVisible;
  this.password = '';
}

validPass() {
  if (this.password) {
    if (this.password === "0000") {
      this.allow_to_change = true;
      this.isPasswordInputVisible = false;
      
    }
}
}

togglePasswordVisibility() {
this.showPassword = !this.showPassword;
}
`

  addFolderDocument: any = `
<button type="button" class="btn-document-add" data-title="Ajouter une tâche">
  <!-- add to class 'btn-details-add' => postion top-right -->
  <i class="fa-solid fa-plus fa fa-lg"></i>
</button>

<button type="button" class="btn-document-add" data-title="Envouyer un dossier">
  <!-- add to class 'btn-details-add' => postion top-right -->
   <i class="fa-solid fa-paper-plane fa fa-lg"></i>
</button>
`;

  isChecked: boolean = false;
  switcher: string = 'Non';
  isPasswordInputVisible: boolean;
  password: string;
  allow_to_change: boolean;
  showPassword: boolean;

  constructor() {}

  ngOnInit(): void {}

  changeToggle() {
    this.isChecked = !this.isChecked;
    this.isChecked ? (this.switcher = 'Oui') : (this.switcher = 'Non');
  }
  
  togglePasswordInput() {
    this.isPasswordInputVisible = !this.isPasswordInputVisible;
    this.password = '';
  }

  validPass() {
    if (this.password) {
      if (this.password === "0000") {
        this.allow_to_change = true;
        this.isPasswordInputVisible = false;
        
      }
  }
}

togglePasswordVisibility() {
  this.showPassword = !this.showPassword;
}

}
